import React, { useState, useEffect } from 'react';
import './css/Formulario_Pacientes.css';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const FormularioPaciente = () => {
  const [formData, setFormData] = useState({
    idPaciente: '', // Este valor será completado automáticamente
    iniciales: '',
    fechaNacimiento: '',
    sexo: '',
    fechaReclutamiento: '',
    protocolo: '521', // Establecemos el protocolo por defecto a 521
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Función para verificar si el idPaciente ya está registrado y obtener el siguiente id
  const getNextIdPaciente = async () => {
    try {
      const response = await fetch('https://api.weareinfinite.mx/paciente/read');
      const data = await response.json();

      // Encontramos el ID más alto en los pacientes existentes
      const maxId = Math.max(...data.map(patient => patient.idPaciente), 0);

      // Devolvemos el siguiente ID incrementado
      return maxId + 1;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '¡Error al verificar ID!',
        text: 'Hubo un problema al verificar el ID del paciente.',
      });
      return 1; // Si no hay datos, comenzamos desde el ID 1
    }
  };

  // Cargar el idPaciente automáticamente cuando el componente se monta
  useEffect(() => {
    const fetchIdPaciente = async () => {
      const newIdPaciente = await getNextIdPaciente();
      setFormData({ ...formData, idPaciente: newIdPaciente.toString() });
    };

    fetchIdPaciente();
  }, []); // Este efecto solo se ejecuta una vez cuando se monta el componente

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validamos que no falten campos obligatorios
    if (!formData.iniciales || !formData.fechaNacimiento || !formData.sexo || !formData.fechaReclutamiento) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor complete todos los campos.',
      });
      return;
    }

    // Preparar datos para enviar
    const dataToSend = {
      ...formData,
      idProtocolo: formData.protocolo, // Se envía el protocolo por defecto
    };

    // Eliminar 'protocolo' porque no se requiere por la API
    delete dataToSend.protocolo;

    try {
      const response = await fetch('https://api.weareinfinite.mx/paciente/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });
      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: '¡Paciente registrado exitosamente!',
          text: 'El paciente ha sido registrado.',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => {
          navigate('/Exel/SMET-40429');
        }, 2000);
      } else {
        Swal.fire({
          icon: 'error',
          title: '¡Error al registrar paciente!',
          text: data.mensaje || 'Verifique los datos e intente nuevamente.',
        }).then(() => {
          navigate('/Exel/SMET-40429');
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '¡Error de conexión!',
        text: 'Hubo un problema al conectar con el servidor.',
      }).then(() => {
        navigate('/Exel/SMET-40429');
      });
    }
  };

  return (
    <div className="container">
      <h2>AÑADIR SUJETO</h2>
      <form onSubmit={handleSubmit}>
        {/* El campo idPaciente ahora se muestra pero es de solo lectura */}
        <input
          type="text"
          name="idPaciente"
          placeholder="ID del Paciente"
          value={formData.idPaciente}
          onChange={handleChange}
          required
          readOnly // Hace que el campo no sea editable
        />
        <input
          type="text"
          name="iniciales"
          placeholder="Iniciales"
          value={formData.iniciales}
          onChange={handleChange}
          required
        />
        <div className="field-group">
          <label htmlFor="fechaNacimiento">Fecha de Nacimiento</label>
          <input
            type="date"
            name="fechaNacimiento"
            id="fechaNacimiento"
            value={formData.fechaNacimiento}
            onChange={handleChange}
            required
          />
        </div>
        <div className="field-group">
          <label>Sexo</label>
          <div className="radio-group">
            <label className="radio-button">
              <input
                type="radio"
                name="sexo"
                value="Masculino"
                checked={formData.sexo === 'Masculino'}
                onChange={handleChange}
              />
              <span>Masculino</span>
            </label>
            <label className="radio-button">
              <input
                type="radio"
                name="sexo"
                value="Femenino"
                checked={formData.sexo === 'Femenino'}
                onChange={handleChange}
              />
              <span>Femenino</span>
            </label>
          </div>
        </div>
        <div className="field-group">
          <label htmlFor="fechaReclutamiento">Fecha de Reclutamiento</label>
          <input
            type="date"
            name="fechaReclutamiento"
            id="fechaReclutamiento"
            value={formData.fechaReclutamiento}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit">Enviar</button>
      </form>
    </div>
  );
};

export default FormularioPaciente;
